<div class="modal-header">
  <h3 class="modal-title">{{ title }}</h3>
  <div class="header-actions">
    <i class="fa" [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
       style="margin-right: 10px; cursor: pointer;" (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<div class="modal-body" [hidden]="minimise">
  @if (showFormLoader) {
<div class="formLoader">
    <i class="fa fa-spinner fa-spin gt-refresh"></i>
  </div>
}
  @if (!showFormLoader) {
<form #diagForm="ngForm">
    <div class="fluid-container">
      <div class="form-group mt-3">
        <label>Tax year</label>
        <input class="form-control" type="text" name="tax_year" [(ngModel)]="rowData.TAX_YEAR" disabled>
      </div>
      <div class="form-group mt-3">
        <label>Form</label>
        <ap-dropdown class="field-full-width" [list]="formOptions" [selectType]="'single'"
          [title]="'Form'" [hideTitleOnInput]="true" [inputAriaLabel]="'Form'"
          [(ngModel)]="selectedFormItem" [ngModelOptions]="{standalone: true}"
          (onSelect)="onFormDropdownSelect($event)">
          @for (item of formOptions; track $index) {
            <ap-dropdown-list-item #dropdownListItem [item]="item"
              [ariaLabel]="setDropdownAriaLabel(item, 'Form')"
              (onSelectItem)="onFormSelectItem($event)"></ap-dropdown-list-item>
          }
        </ap-dropdown>
      </div>
      <div class="form-group mt-3">
        <label>Reverse account</label>
        <ap-dropdown class="field-full-width" [list]="reverseAcctOptions" [selectType]="'single'"
          [title]="'Reverse account'" [hideTitleOnInput]="true" [inputAriaLabel]="'Reverse account'"
          [disabled]="reverseAcctOptions.length === 0"
          [(ngModel)]="selectedRevAcctItem" [ngModelOptions]="{standalone: true}"
          (onSelect)="onValueDropdownSelect($event, 'REV_ACCT')">
          @for (item of reverseAcctOptions; track $index) {
            <ap-dropdown-list-item #dropdownListItem [item]="item"
              [ariaLabel]="setDropdownAriaLabel(item, 'Reverse account')"
              (onSelectItem)="onValueSelectItem($event, 'REV_ACCT')"></ap-dropdown-list-item>
          }
        </ap-dropdown>
      </div>
      <div class="form-group mt-3">
        <label>Calculation account</label>
        <ap-dropdown class="field-full-width" [list]="reverseAcctOptions" [selectType]="'single'"
          [title]="'Calculation account'" [hideTitleOnInput]="true" [inputAriaLabel]="'Calculation account'"
          [disabled]="reverseAcctOptions.length === 0"
          [(ngModel)]="selectedCalcAcctItem" [ngModelOptions]="{standalone: true}"
          (onSelect)="onValueDropdownSelect($event, 'CALC_ACCT')">
          @for (item of reverseAcctOptions; track $index) {
            <ap-dropdown-list-item #dropdownListItem [item]="item"
              [ariaLabel]="setDropdownAriaLabel(item, 'Calculation account')"
              (onSelectItem)="onValueSelectItem($event, 'CALC_ACCT')"></ap-dropdown-list-item>
          }
        </ap-dropdown>
      </div>
      <div class="form-group mt-3">
        <label>Calculation type</label>
        <ap-dropdown class="field-full-width" [list]="calcTypeOptions" [selectType]="'single'"
          [title]="'Calculation type'" [hideTitleOnInput]="true" [inputAriaLabel]="'Calculation type'"
          [(ngModel)]="selectedCalcTypeItem" [ngModelOptions]="{standalone: true}"
          (onSelect)="onValueDropdownSelect($event, 'CALC_TYPE')">
          @for (item of calcTypeOptions; track $index) {
            <ap-dropdown-list-item #dropdownListItem [item]="item"
              [ariaLabel]="setDropdownAriaLabel(item, 'Calculation type')"
              (onSelectItem)="onValueSelectItem($event, 'CALC_TYPE')"></ap-dropdown-list-item>
          }
        </ap-dropdown>
      </div>
      <div class="form-group mt-3">
        <label>Calculation number</label>
        <input class="form-control" type="number" step="any" name="calc_num" [(ngModel)]="rowData.CALC_NUM">
      </div>
      <div class="form-group mt-3">
        <label>Exclude account</label>
        <ap-dropdown class="field-full-width" [list]="reverseAcctOptions" [selectType]="'single'"
          [title]="'Exclude account'" [hideTitleOnInput]="true" [inputAriaLabel]="'Exclude account'"
          [disabled]="reverseAcctOptions.length === 0"
          [(ngModel)]="selectedExcludeAcctItem" [ngModelOptions]="{standalone: true}"
          (onSelect)="onValueDropdownSelect($event, 'EXCLUDE_ACCT')">
          @for (item of reverseAcctOptions; track $index) {
            <ap-dropdown-list-item #dropdownListItem [item]="item"
              [ariaLabel]="setDropdownAriaLabel(item, 'Exclude account')"
              (onSelectItem)="onValueSelectItem($event, 'EXCLUDE_ACCT')"></ap-dropdown-list-item>
          }
        </ap-dropdown>
      </div>
      <div class="form-group mt-3">
        <label>Active</label>
        <ap-dropdown class="field-full-width" [list]="activeOptions" [selectType]="'single'"
          [title]="'Active'" [hideTitleOnInput]="true" [inputAriaLabel]="'Active'"
          [(ngModel)]="selectedActiveItem" [ngModelOptions]="{standalone: true}"
          (onSelect)="onValueDropdownSelect($event, 'IS_ACTIVE')">
          @for (item of activeOptions; track $index) {
            <ap-dropdown-list-item #dropdownListItem [item]="item"
              [ariaLabel]="setDropdownAriaLabel(item, 'Active')"
              (onSelectItem)="onValueSelectItem($event, 'IS_ACTIVE')"></ap-dropdown-list-item>
          }
        </ap-dropdown>
      </div>
    </div>
  </form>
}
</div>

<div class="modal-footer" [hidden]="minimise">
  <button class="save-button" type="button" [disabled]="saving" (click)="save()">
    @if (saving) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
} Save
  </button>
  <button class="cancel-button" type="button" (click)="cancel()">Cancel</button>
</div>
